import React, { useEffect, useState } from 'react';
import { IconClose } from '~/assets/Icons';
import {
  Page,
  TablePage,
  PageHeader,
  Loading,
  ModalDefault,
  Button,
  Modal,
} from '~/components';
import BiblicalSchool from '~/services/BiblicalSchool';
import frequencyService from '~/services/frequencyService';
import {
  ClasseList,
  Content,
  ContentModal,
  DeletDiv,
  TitleModal,
} from './styles';

const Sent: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState<any>([]);
  const [dataSourceDetails, setDataSourceDetails] = useState<any>({});
  const [dataSourceClasse, setDataSourceClasse] = useState<any>([]);
  const [input, setInput] = useState('');
  const [isVisibleModalDetails, setIsVisibleModalDetails] = useState(false);
  const [isVisibleModalErro, setIsVisibleModalErro] = useState(false);
  const [period, setPeriod] = useState<{ year: number; quarter: number }>();
  const [keptArr, setKeptArr] = useState([]);

  const loadReports = async ({
    year,
    quarter,
  }: {
    year: number;
    quarter: number;
  }) => {
    setLoading(true);
    try {
      const res = await BiblicalSchool.ListUpdateClasseRequest({
        year,
        quarter,
      });
      setDataSource(res);
    } catch (e) {
      console.log(e);
      setIsVisibleModalErro(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadClasses = async () => {
      const res = await frequencyService.listAllClasses();
      setDataSourceClasse(res.result);
    };

    const loadInitialPeriodAndReports = async () => {
      setLoading(true);
      try {
        const currentPeriod = await BiblicalSchool.GetUpdateClassesPeriod();
        setPeriod({ year: currentPeriod.year, quarter: currentPeriod.quarter });
        await loadReports({
          year: currentPeriod.year,
          quarter: currentPeriod.quarter,
        });
      } catch (e) {
        console.log(e);
        setIsVisibleModalErro(true);
        setLoading(false);
      }
    };

    loadClasses();
    loadInitialPeriodAndReports();
  }, []);

  const acceptRequest = async () => {
    if (!period) return;

    setLoading(true);
    try {
      await frequencyService.ApproveRequestUpdate(dataSourceDetails.id);
      setIsVisibleModalDetails(false);
    } catch (e) {
      console.log(e);
      setIsVisibleModalErro(true);
    }
    await loadReports({
      year: period.year,
      quarter: period.quarter,
    });
    setLoading(false);
  };

  const rejectRequest = async () => {
    if (!period) return;

    setLoading(true);
    try {
      await frequencyService.DisapproveRequestUpdate(dataSourceDetails.id);
      setIsVisibleModalDetails(false);
    } catch (e) {
      console.log(e);
      setIsVisibleModalErro(true);
    }
    await loadReports({
      year: period.year,
      quarter: period.quarter,
    });
    setLoading(false);
  };

  const columns = [
    {
      title: 'Igreja',
      dataIndex: 'church',
      key: 'church',
      render: (e: { name: string }) => e?.name,
    },
    {
      key: 'action',
      width: '150px',
      render: (e: any) => (
        <Button
          onClick={() => {
            setDataSourceDetails(e);
            setKeptArr(
              e.classesId.filter(
                (classes: any) => !e.addedClassesId.includes(classes),
              ),
            );
            setIsVisibleModalDetails(true);
          }}
        >
          Ver Mais
        </Button>
      ),
    },
  ];

  if (loading) {
    return (
      <Page>
        <Loading />
      </Page>
    );
  }

  return (
    <>
      {isVisibleModalErro && (
        <ModalDefault
          success={false}
          onClick={() => setIsVisibleModalErro(false)}
        >
          Ops algo deu errado
        </ModalDefault>
      )}
      {isVisibleModalDetails && (
        <Modal>
          <DeletDiv>
            <TitleModal>
              <button
                type="button"
                onClick={() => setIsVisibleModalDetails(false)}
              >
                <IconClose />
              </button>
            </TitleModal>
            <ContentModal>
              {keptArr.length > 0 && (
                <>
                  <b>Classes Mantidas</b>
                  {keptArr.map((e: any) => {
                    const classe = dataSourceClasse.find(
                      (classe: any) => classe.id === e,
                    );
                    return <ClasseList state={3}>{classe.name}</ClasseList>;
                  })}
                </>
              )}
              {dataSourceDetails.addedClassesId.length > 0 && (
                <>
                  <b>Classes Adicionadas</b>
                  {dataSourceDetails.addedClassesId.map((e: any) => {
                    const classe = dataSourceClasse.find(
                      (classe: any) => classe.id === e,
                    );
                    return <ClasseList state={1}>{classe.name}</ClasseList>;
                  })}
                </>
              )}
              {dataSourceDetails.removedClassesId.length > 0 && (
                <>
                  <b>Classes Removidas</b>
                  {dataSourceDetails.removedClassesId.map((e: any) => {
                    const classe = dataSourceClasse.find(
                      (classe: any) => classe.id === e,
                    );
                    return <ClasseList state={2}>{classe.name}</ClasseList>;
                  })}
                </>
              )}
              <Button onClick={() => acceptRequest()}>Aprovar</Button>
              <Button styles={1} onClick={() => rejectRequest()}>
                Rejeitar
              </Button>
            </ContentModal>
          </DeletDiv>
        </Modal>
      )}

      <Page>
        <PageHeader
          title="Solicitações de Alteração"
          onChange={e => setInput(e)}
        />
        <Content>
          <TablePage
            columns={columns}
            dataSource={dataSource.filter((element: any) =>
              element?.church?.name.toLowerCase().includes(input.toLowerCase()),
            )}
            rowKey="id"
          />
        </Content>
      </Page>
    </>
  );
};

export default Sent;
